module.exports = __webpack_public_path__ + "img/ons_campaign_4_title.58e2d2c4.png";